import script from "./AssessmentFinanceFees.vue?vue&type=script&setup=true&lang=js"
export * from "./AssessmentFinanceFees.vue?vue&type=script&setup=true&lang=js"

import "./AssessmentFinanceFees.vue?vue&type=style&index=0&id=54f6a6ab&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54f6a6ab"]])

export default __exports__